/* eslint-disable no-return-await */
import { api } from "jiffy-api";
import { track } from "jiffy-analytics";
import "./digital-assets-add-to-cart.scss";
import EventClass from "common/utils/ui/event-class";
import { updateHeaderCounter } from "components/jiffy/masthead-cart/masthead-cart";

export class DigitalAssetsAddToCart extends EventClass {
  #submitButtonSelector = "";

  #$form = undefined;

  #isDisabledForm = false;

  #addedToCart = undefined;

  constructor({ formSelector, submitButtonSelector, addedToCart }) {
    super({
      eventSelector: formSelector,
      event: "submit"
    });

    this.#addedToCart = addedToCart;
    this.#submitButtonSelector = submitButtonSelector;
  }

  get #$submitButton() {
    return this.#$form.querySelector(this.#submitButtonSelector);
  }

  async #requestForm() {
    const formData = new FormData(this.#$form);
    return await api.digitalAssets.addToCart(formData, {
      raw: true,
      headers: {
        "Content-Type": undefined
      }
    });
  }

  get #trackData() {
    const {
      sku,
      product,
      author,
      pageName,
      context,
      businessLine,
      fulfillmentGroup,
      brand,
      quantity
    } = this.#$form.dataset;

    return {
      click_context: context,
      business_line: businessLine,
      fulfillment_group: fulfillmentGroup,
      brand,
      author,
      sku,
      product,
      quantity,
      page_name: pageName
    };
  }

  #disableForm() {
    this.#isDisabledForm = true;
    this.#$submitButton.setAttribute("disabled", "disabled");
  }

  #enableForm() {
    this.#isDisabledForm = false;
    this.#$submitButton.removeAttribute("disabled");
  }

  #addedToCartCallback(responseData) {
    const { image, price, title } = this.#$form.dataset;
    const assetInfo = { image, price, title };
    this.#addedToCart?.({ assetInfo, responseData, trackData: this.#trackData });
  }

  /**
   * @returns {Promise<void>}
   * @override EventClass.event
   * @description This method is called when the form is submitted.
   */
  async event(event, target) {
    event.preventDefault();

    if (this.#isDisabledForm) return;

    this.#$form = target;

    this.#disableForm();
    try {
      const responseData = await this.#requestForm();
      this.#addedToCartCallback(responseData);
      updateHeaderCounter(responseData.total_items_qty);
      track("product_added", this.#trackData);
    } catch ({ message = "Unexpected error" }) {
      window.alert(`An error occurred: ${message}`); // eslint-disable-line no-alert
    }

    this.#enableForm();
  }
}

export default props =>
  new DigitalAssetsAddToCart({
    formSelector: ".js-product-details-quantity-form",
    submitButtonSelector: ".js-product-details-quantity-form-submit",
    ...props
  });
